export enum DeviceType {
  SENSOR = 'SENSOR',
  TEMPERATURE = 'TEMPERATURE',
  HUMIDITY = 'HUMIDITY',
  TEMP_HUMIDITY = 'TEMP_HUMIDITY',
  LEVEL = 'LEVEL',
  ENERGY = 'ENERGY',
  POWER = 'POWER',
  WATER = 'WATER',
  DIESEL = 'DIESEL',
  GAS = 'GAS',
  MOTION = 'MOTION',
  DOOR = 'DOOR',
  CAMERA = 'CAMERA',
  ACTUATOR = 'ACTUATOR',
  MULTI_SENSOR = 'MULTI_SENSOR',
  DIFFERENTIAL_PRESSURE = 'DIFFERENTIAL_PRESSURE',
}

export const DeviceTypeLabels: Record<DeviceType, { en: string; ar: string; icon: string }> = {
  [DeviceType.SENSOR]: { en: 'Generic Sensor', ar: 'حساس عام', icon: 'hardware-chip' },
  [DeviceType.TEMPERATURE]: { en: 'Temperature Sensor', ar: 'حساس حرارة', icon: 'thermometer' },
  [DeviceType.HUMIDITY]: { en: 'Humidity Sensor', ar: 'حساس رطوبة', icon: 'water' },
  [DeviceType.TEMP_HUMIDITY]: { en: 'Temp & Humidity', ar: 'حرارة ورطوبة', icon: 'partly-sunny' },
  [DeviceType.LEVEL]: { en: 'Level Sensor', ar: 'حساس مستوى', icon: 'analytics' },
  [DeviceType.ENERGY]: { en: 'Energy Meter', ar: 'عداد طاقة', icon: 'flash' },
  [DeviceType.POWER]: { en: 'Power Meter', ar: 'عداد قدرة', icon: 'battery-charging' },
  [DeviceType.WATER]: { en: 'Water Meter', ar: 'عداد ماء', icon: 'water-outline' },
  [DeviceType.DIESEL]: { en: 'Diesel Tank', ar: 'خزان ديزل', icon: 'flame-outline' },
  [DeviceType.GAS]: { en: 'Gas Meter', ar: 'عداد غاز', icon: 'flame' },
  [DeviceType.MOTION]: { en: 'Motion Sensor', ar: 'حساس حركة', icon: 'walk' },
  [DeviceType.DOOR]: { en: 'Door Sensor', ar: 'حساس باب', icon: 'exit' },
  [DeviceType.CAMERA]: { en: 'Camera', ar: 'كاميرا', icon: 'camera' },
  [DeviceType.ACTUATOR]: { en: 'Actuator', ar: 'مشغل', icon: 'toggle' },
  [DeviceType.MULTI_SENSOR]: { en: 'Multi-Sensor', ar: 'حساس متعدد', icon: 'grid' },
  [DeviceType.DIFFERENTIAL_PRESSURE]: {
    en: 'Differential Pressure',
    ar: 'حساس الضغط التفاضلي',
    icon: 'speedometer',
  },
};

// Helper to get device type label
export function getDeviceTypeLabel(type: DeviceType, language: 'en' | 'ar'): string {
  return DeviceTypeLabels[type]?.[language] || DeviceTypeLabels[DeviceType.SENSOR][language];
}

// Helper to get device type icon
export function getDeviceTypeIcon(type: DeviceType): string {
  return DeviceTypeLabels[type]?.icon || DeviceTypeLabels[DeviceType.SENSOR].icon;
}

// Get all device types as array
export function getAllDeviceTypes(): DeviceType[] {
  return Object.values(DeviceType);
}
